<template><span></span></template>
<script>export default {
    data: () => ({
        isPropagated: false
    }),
    methods: {
        listMemberships() {
            if(!this.$store.state.cards) return [];
            let today = new Date();
            today.setHours(0, 0, 0, 0);
            const retArray = this.$store.state.cards.filter(item => {
                let validToDate = item.validToDate ? new Date(item.validToDate) : null;
                if (validToDate) validToDate.setHours(0, 0, 0, 0);
                let num = parseInt(item.price);
                item.price = isNaN(num) ? 0 : num;
                return (item.validToDate === null || validToDate >= today) || item.trainingsLeft > 0;
            });
            const price = retArray.reduce((total, item) => total + (item.price || 0), 0);
            const cardTypes = retArray.map(item => item.cardtype_name).join('\n');
            return {
            	has_membership: retArray.length > 0,
                memberships: cardTypes,
                value: price
            };
        },
        encode(prop) {
            if (!prop) return null;
        	return this.sha256(prop.trim());
        },
        replaceZeroWith46(str) {
            if (str.startsWith('0')) {
                return '46' + str.slice(1);
            }
            return str.replace("+", "");
        },
        convertPhone(string) {
          if (!string) return null
          let newString = this.replaceZeroWith46(string).match(/[0-9]{0,14}/g);
          if (newString === null) {
            return '';
          }
          // Join parts returned from RegEx match
          newString = newString.join('');
          // Start number with "+"
          newString = '+' + newString;
          // Limit length to 15 characters
          newString = newString.substring(0, 15);
          return newString;
        },
        async sha256(val) {
        	return await crypto.subtle
                .digest('SHA-256', new TextEncoder('utf-8').encode(val))
                .then(h => {
                  let hexes = [],
                    view = new DataView(h);
                  for (let i = 0; i < view.byteLength; i += 4)
                    hexes.push(('00000000' + view.getUint32(i).toString(16)).slice(-8));
                  return hexes.join('');
                });
        },
        async setUserData() {
            if (this.$store.state.user && this.$store.state.user.login_key && !this.isPropagated) {
        		window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'zid': this.$store.state.user.id
                });
                window.dataLayer.push({'user_data': {
                    "sha256_email_address": await this.encode(this.$store.state.user.mail),
                    "sha256_phone_number": await this.encode(this.convertPhone(this.$store.state.user.phone)),
                    "email_address": this.$store.state.user.mail,
                    "phone_number": this.convertPhone(this.$store.state.user.phone),
                    "address": {
                        "first_name": this.$store.state.user.firstname,
                        "last_name": this.$store.state.user.lastname,
                        "sha256_first_name": await this.encode(this.$store.state.user.firstname),
                        "sha256_last_name": await this.encode(this.$store.state.user.lastname),
                        "street": this.$store.state.user.address,
                        "city": this.$store.state.user.city,
                        "postal_code": this.$store.state.user.zipCode,
                        "country": "SE"
                    }
                }});
                const user_memberships = this.listMemberships();
                window.dataLayer.push({
                    'event': 'hs_contact',
                    'hs_data': {
                        "email_address": this.$store.state.user.mail,
                        "user_id": this.$store.state.user.id,
                        "phone_number": this.convertPhone(this.$store.state.user.phone),
                        "address": {
                            "first_name": this.$store.state.user.firstname,
                            "last_name": this.$store.state.user.lastname,
                            "street": this.$store.state.user.address,
                            "city": this.$store.state.user.city,
                            "postal_code": this.$store.state.user.zipCode,
                            "country": "SE"
                        },
                        "selectedSite": this.$store.selectedSiteId,
                        "has_membership": user_memberships.has_membership ? "active" : "passive",
                        "memberships": user_memberships.memberships,
                        "mvalue": user_memberships.value
                	}
                });
                this.isPropagated = true;
            }
        }
    },
    mounted() {
        this.setUserData();
    },
    watch: {
      '$store.state.isLoggedIn': {
        deep: true,
        handler() {
          this.setUserData();
        }
      }
    }
}</script>